module.exports = __webpack_public_path__ + "img/蒙版组 1@2x (2).7f83ca57.webp";